import { useContext } from 'react';
import { useDispatch } from 'react-redux-latest';
import FileUpload, { DropResult } from '../../../../../../../../components/file-upload';
import { ActionState } from '../../../../../../../../enums/actions';
import { UploadCompaniesContext } from '../../../../../../../../providers/upload-companies-provider';
import { resetImportProspects } from '../../../../../../../../redux/actions';
import { AppDispatch } from '../../../../../../../../redux/store/configureStore';
import UploadListStyled from './modal-upload-list.styled';

export const CSV_LIMIT = 5000;

const UploadList = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { handleUpdateSelectedColumn, handleActionStateChange, handleUpdateCsvData } =
        useContext(UploadCompaniesContext);

    const handleResult = (data: DropResult) => {
        handleUpdateCsvData(data);
    };

    const handleColumnSelected = (columnName: string | null) => {
        if (!columnName) {
            handleActionStateChange(ActionState.DISABLED);
            return;
        }
        handleUpdateSelectedColumn(columnName);
        handleActionStateChange(ActionState.ENABLED);
    };

    const handleResetAll = () => {
        dispatch(resetImportProspects());
    };

    return (
        <UploadListStyled>
            <div className="information">
                Upload a CSV list containing company names or domains like <span className="pill">Worko</span> or{' '}
                <span className="pill">Zaplify.com</span>
            </div>
            <FileUpload
                columnSelection={true}
                onColumnSelected={handleColumnSelected}
                onResult={handleResult}
                dataValidator={({ results }) => {
                    const errors: string[] = [];

                    if (results.length > CSV_LIMIT) {
                        errors.push(`You can only upload a maximum of ${CSV_LIMIT} companies`);
                    }
                    return errors;
                }}
                onResetAll={handleResetAll}
            />
        </UploadListStyled>
    );
};

export default UploadList;
